import { ReactElement } from "react";
import styled from "styled-components";
import { AnyComponent } from "styled-components/dist/types";
import { MessageStyles } from "../../types";
import Icon, { IconType } from "../Icon/Icon";

export type SubtitleProps = {
  children: ReactElement<AnyComponent> | string;
  icon?: IconType;
  styles?: MessageStyles;
  dataId?: string;
};

const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledLabel = styled.label<{
  colour?: string;
  backgroundColour?: string;
}>`
  display: flex;
  align-items: center;
  column-gap: 4px;
  padding: 10px;
  border-radius: 4px;
  font-size: 13px;
  background-color: ${({ backgroundColour }) => backgroundColour};
  color: ${({ colour }) => colour};
`;

const StyledIcon = styled(Icon)`
  padding: 3px 5px;
  font-size: 14px;
`;

export const Subtitle: React.FC<SubtitleProps> = ({
  children,
  icon,
  styles = {
    OverallMessageTextColour: "#202227",
    OverallMessageBackgroundColour: "#f6ecf1",
  },
  dataId,
}) => {
  return (
    <StyledLabel
      colour={styles.OverallMessageTextColour}
      backgroundColour={styles.OverallMessageBackgroundColour}
      data-id={dataId}
    >
      {icon && (
        <IconWrapper>
          <StyledIcon icon={icon} color={styles.OverallMessageTextColour} />
        </IconWrapper>
      )}
      {children}
    </StyledLabel>
  );
};

export default Subtitle;
